import React from "react";
import AddIcon from "@mui/icons-material/Add";
import Controls from "src/components/form/controls/Controls";
import { isOpenPopup } from "src/utils/isOpenPopup";
import Popup from "src/components/popup/Popup";
import DistrictForm from "../Form/DistrictForm/DistrictForm";

const DistrictPopup = ({
  openPopup,
  setOpenPopup,
  recordForEdit,
  addOrEdit,
  handleOpenPopup,
}) => {
  return (
    <>
      <Controls.Button
        text="Add New"
        variant="outlined"
        startIcon={<AddIcon />}
        onClick={() => {
          handleOpenPopup(isOpenPopup, null);
        }}
      />

      <Popup
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              marginTop: "-10%",
              width: "100%",
              maxWidth: "500px",
            },
          },
        }}
        title={!recordForEdit ? "Create District" : "Edit District"}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <DistrictForm addOrEdit={addOrEdit} recordForEdit={recordForEdit} />
      </Popup>
    </>
  );
};

export default DistrictPopup;
